import crypto from 'crypto'

const getHashedEmail = (email: string) => {
  if (!email.includes('@')) {
    return email
  }

  return crypto
    .createHash('sha256')
    .update(email.toLowerCase())
    .digest()
    .toString('base64')
}

export default getHashedEmail
